"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ImageSwatch", {
    enumerable: true,
    get: function() {
        return ImageSwatch;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useImageSwatch = require("./useImageSwatch");
const _renderImageSwatch = require("./renderImageSwatch");
const _useImageSwatchStylesstyles = require("./useImageSwatchStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ImageSwatch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useImageSwatch.useImageSwatch_unstable)(props, ref);
    (0, _useImageSwatchStylesstyles.useImageSwatchStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useImageSwatchStyles_unstable')(state);
    return (0, _renderImageSwatch.renderImageSwatch_unstable)(state);
});
ImageSwatch.displayName = 'ImageSwatch';
